module.exports = __webpack_public_path__ + "img/msg.b2e44226.svg";